import api from '@/api/axiosApi'
import type { ExportRead } from '@/types'
import type { CreateExportResponse } from '@/hooks/useExport'

export interface CreatePlanExportRequest {
  q?: string
  status?: string
}

export interface CreateLineExportRequest {
  columns?: string[] | null
  sort?: string | null
  workflow_status?: string | null
  sku_number?: string | null
  vendor_id?: string | null
}

export type { CreateExportResponse }

/**
 * Create a new plan export job
 * POST /plans/exports
 */
export async function createPlanExport(
  request?: CreatePlanExportRequest
): Promise<CreateExportResponse> {
  const params: Record<string, string> = {}

  if (request?.q) {
    params.q = request.q
  }

  if (request?.status) {
    params.status = request.status
  }

  const response = await api.post<CreateExportResponse>(
    '/plans/exports',
    {},
    { params }
  )
  return response.data
}

/**
 * Get export status and download URL
 * GET /plans/exports/{exportId}
 */
export async function getPlanExport(exportId: string): Promise<ExportRead> {
  const response = await api.get<ExportRead>(`/plans/exports/${exportId}`)
  return response.data
}

/**
 * Create a new plan lines export job
 * POST /plans/{planId}/versions/{versionId}/lines/exports
 */
export async function createLineExport(
  planId: string,
  versionId: string,
  request?: CreateLineExportRequest
): Promise<CreateExportResponse> {
  const response = await api.post<CreateExportResponse>(
    `/plans/${planId}/versions/${versionId}/lines/exports`,
    request ?? {}
  )
  return response.data
}

/**
 * Get plan lines export status and download URL
 * GET /plans/{planId}/versions/{versionId}/lines/exports/{exportId}
 */
export async function getLineExport(
  planId: string,
  versionId: string,
  exportId: string
): Promise<ExportRead> {
  const response = await api.get<ExportRead>(
    `/plans/${planId}/versions/${versionId}/lines/exports/${exportId}`
  )
  return response.data
}
